import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDM-EzDXJo5A9OEGVyG7pXw8aLimrpqeKE",
  authDomain: "sagrf-58234.firebaseapp.com",
  projectId: "sagrf-58234",
  storageBucket: "sagrf-58234.firebasestorage.app",
  messagingSenderId: "282236839862",
  appId: "1:282236839862:web:a1aaf8950b748c341e0317",
  measurementId: "G-2YXVSYVGRZ"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

// Temporarily disable analytics to see if that's causing the issue
// export const analytics = getAnalytics(app);

export default app; 